/* eslint-disable no-unsafe-optional-chaining */
import { useFormik } from "formik";
import { useEffect, useState } from "react";
// import firebase from 'firebase';
import { Oval } from "react-loader-spinner";
import search from "../../assets/icons/search.svg";
import trash from "../../assets/icons/trash-solid.svg";

// import 'firebase/firestore';
// import { firestore, storage } from '../firebase';

import CreditFront from "../../assets/icons/icons8-credit-card-100.png";
import CreditBack from "../../assets/icons/icons8-magnetic-card-100.png";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const CustomerReservation = () => {
    const [message, setMessage] = useState("");
    const [front, setFront] = useState("");
    const [back, setBack] = useState("");

    const [picUploading1, setPicUploading1] = useState(false);
    const [picUploading2, setPicUploading2] = useState(false);

    useEffect(() => {
        // Check to see if this is a redirect back from Checkout
        const query = new URLSearchParams(window.location.search);
        //  console.log(query.get("resID"))

        if (query.get("success")) {
            setMessage("Order placed! You will receive an email confirmation.");
            // firestore
            //   .collection("Reservations")
            //   .doc(query.get("resID"))
            //   .update({
            //     isPaid: true,
            //   })
            //   .then(() => {
            //     Swal.fire("Good job!", `${message}`, "success").then((result) => {
            //       if (result.isConfirmed) {
            //         window.location.href = "/customer-reservation";
            //       }
            //     });
            //   });
        }

        if (query.get("canceled")) {
            setMessage("Order canceled -- continue to shop around and checkout when you're ready.");
            window.location.href = "/customer-reservation";
        }
    }, []);

    if (message) {
        //  alert(message);
        setMessage("");
    }
    const [datasUsers, setDatasUsers] = useState([]);

    const [isSubmit, setIsSubmit] = useState(false);

    // console.log(datasUsers);

    //  const [stripePromise, setStripePromise] = useState(null);

    //  useEffect(() => {
    //     fetch("/car-app-stripe").then(async (r) => {
    //        const { publishableKey } = await r.json();
    //        setStripePromise(loadStripe(publishableKey));
    //     });
    //  }, []);

    //  useEffect(() => {
    //     fetch("/car-app-stripe", {
    //        method: "POST",
    //        body: JSON.stringify({}),
    //     }).then(async (result) => {
    //        var { clientSecret } = await result.json();
    //        setClientSecret(clientSecret);
    //     });
    //  }, []);

    const [index, setIndex] = useState();
    // console.log(index);

    const [render, setRerender] = useState(0);

    const [, setCarData] = useState();
    const [cars, setCars] = useState([]);
    const [amount, setAmount] = useState(0);

    // console.log("cars", cars);

    // const []

    useEffect(() => {}, [render]);

    const [users, setUsers] = useState([]);

    const [carIndex, setCarIndex] = useState([]);

    const [reserveNum, setReserveNum] = useState([]);

    const [additionalImg, setAdditionalImg] = useState();

    const [discountAmount, setDiscountAmount] = useState();

    const [invoice, setInvoice] = useState([]);

    // useEffect(() => {
    //   fetch("https://softcar-chrentacar-test-43b9adc2e8ec.herokuapp.com/create-payment-intent", {
    //     method: "POST",
    //     body: JSON.stringify({}),
    //   }).then(async (result) => {
    //     var { clientSecret } = await result.json();
    //     setClientSecret(clientSecret);
    //   });
    // }, []);

    //  const traveler = [
    //     { description: "Senior", Amount: 50 },
    //     { description: "Senior", Amount: 50 },
    //     { description: "Adult", Amount: 75 },
    //     { description: "Child", Amount: 35 },
    //     { description: "Infant", Amount: 25 },
    //  ];

    //  console.log(invoice.reduce((n, { total }) => n + total, 0));

    // Expected output: 10

    // console.log(invoice);

    const [invoice1, setInvoice1] = useState([]);

    const [mainInvoice, setMainInvoice] = useState([]);

    useEffect(() => {
        setMainInvoice([...invoice, ...invoice1]);
    }, [invoice, invoice.length, invoice1, invoice1.length]);
    // console.log(mainInvoice);

    // console.log(invoice);

    useEffect(() => {}, [invoice.length]);

    function getDifferenceInDays(date1, date2) {
        const diffInMs = Math.abs(new Date(date2) - new Date(date1));
        return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    }

    const [inputValue, setInputValue] = useState("");

    const [inputValue1, setInputValue1] = useState("");

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleChange1 = (event) => {
        setInputValue1(event.target.value);
    };

    // function delay(t, v) {
    //     return new Promise((resolve) => {
    //         setTimeout(resolve.bind(null, v), t);
    //     });
    // }

    // function keepTrying(triesRemaining, storageRef) {
    //     if (triesRemaining < 0) {
    //         return Promise.reject(new Error("out of tries"));
    //     }

    //     return storageRef
    //         .getDownloadURL()
    //         .then((url) => url)
    //         .catch((err) => {
    //             switch (err.code) {
    //                 case "storage/object-not-found":
    //                     return delay(2000).then(() => keepTrying(triesRemaining - 1, storageRef));
    //                 default:
    //                     return Promise.reject(err);
    //             }
    //         });
    // }

    const car1Change = (e) => {
        if (e.target.files[0]) {
            setPicUploading1(true);
            // const uploadCar1 = storage.ref(`CreditCard/${e.target.files[0].name}`).put(e.target.files[0]);

            // uploadCar1.on(
            //     "state_changed",
            //     (snapshot) => {},
            //     (error) => {
            //         setError(error);
            //         setPicUploading1(false);
            //     },
            //     () => {
            //         // storage
            //         //   .ref("Cars")
            //         //   .child(
            //         //     `${formik.values.carNumber}_1${e.target.files[0].name
            //         //       .split(".")
            //         //       .slice(0, -1)
            //         //       .join(".")}_250x250.${e.target.files[0].name.split(".").pop()}`
            //         //   )
            //         //   .getDownloadURL()
            //         // .then((url) => {
            //         //   setCar1(url);
            //         //   setPicUploading1(false);
            //         // });
            //         keepTrying(
            //             10,
            //             storage
            //                 .ref("CreditCard")
            //                 .child(
            //                     `${e.target.files[0].name
            //                         .split(".")
            //                         .slice(0, -1)
            //                         .join(".")}_500x500.${e.target.files[0].name.split(".").pop()}`,
            //                 ),
            //         ).then((url) => {
            //             setFront(url);
            //             // console.log("urlll",url);
            //             setPicUploading1(false);
            //         });
            //     },
            // );

            // Placeholder functionality
            setTimeout(() => {
                setFront("placeholder-url");
                setPicUploading1(false);
            }, 1000);
        }
    };

    const car2Change = (e) => {
        if (e.target.files[0]) {
            setPicUploading2(true);
            // const uploadCar2 = storage.ref(`CreditCard/${e.target.files[0].name}`).put(e.target.files[0]);
            // uploadCar2.on(
            //     "state_changed",
            //     (snapshot) => {},
            //     (error) => {
            //         setError(error);
            //         setPicUploading2(false);
            //     },
            //     () => {
            //         // storage
            //         //   .ref("Cars")
            //         //   .child(`${formik.values.carNumber}_2${e.target.files[0].name}`)
            //         //   .getDownloadURL()
            //         //   .then((url) => {
            //         //     setCar2(url);
            //         //     setPicUploading2(false);
            //         //   });
            //         keepTrying(
            //             10,
            //             storage
            //                 .ref("CreditCard")
            //                 .child(
            //                     `${e.target.files[0].name
            //                         .split(".")
            //                         .slice(0, -1)
            //                         .join(".")}_500x500.${e.target.files[0].name.split(".").pop()}`,
            //                 ),
            //         ).then((url) => {
            //             setBack(url);
            //             setPicUploading2(false);
            //         });
            //     },
            // );

            // Placeholder functionality
            setTimeout(() => {
                setBack("placeholder-url");
                setPicUploading2(false);
            }, 1000);
        }
    };

    const additionalInfo = (e) => {
        if (e.target.files[0]) {
            // setPicUploading2(true);
            // const uploadCar2 = storage.ref(`AdditonalInfo/${e.target.files[0].name}`).put(e.target.files[0]);
            // uploadCar2.on(
            //     "state_changed",
            //     (snapshot) => {},
            //     (error) => {
            //         setError(error);
            //         // setPicUploading2(false);
            //     },
            //     () => {
            //         // storage
            //         //   .ref("Cars")
            //         //   .child(`${formik.values.carNumber}_2${e.target.files[0].name}`)
            //         //   .getDownloadURL()
            //         //   .then((url) => {
            //         //     setCar2(url);
            //         //     setPicUploading2(false);
            //         //   });
            //         if (e.target.files[0].name.split(".").pop() === "pdf") {
            //             keepTrying(
            //                 10,
            //                 storage
            //                     .ref("AdditonalInfo")
            //                     .child(
            //                         `${e.target.files[0].name
            //                             .split(".")
            //                             .slice(0, -1)
            //                             .join(".")}.${e.target.files[0].name.split(".").pop()}`,
            //                     ),
            //             ).then((url) => {
            //                 setAdditionalImg(url);
            //                 // setPicUploading2(false);
            //             });
            //         } else {
            //             keepTrying(
            //                 10,
            //                 storage
            //                     .ref("AdditonalInfo")
            //                     .child(
            //                         `${e.target.files[0].name
            //                             .split(".")
            //                             .slice(0, -1)
            //                             .join(".")}_500x500.${e.target.files[0].name.split(".").pop()}`,
            //                     ),
            //             ).then((url) => {
            //                 setAdditionalImg(url);
            //                 // setPicUploading2(false);
            //             });
            //         }
            //     },
            // );

            // Placeholder functionality
            setTimeout(() => {
                setAdditionalImg("placeholder-url");
            }, 1000);
        }
    };

    function getInputValue() {
        // Selecting the input element and get its value
        const inputVal = document.getElementById("myInput").value;
        setDiscountAmount(inputVal);
    }

    // Displaying the value
    useEffect(() => {}, []);

    // const [invoiceTotal, setInvoiceTotal] = useState(
    //    invoice.data.weekly.total +
    //       invoice.data.miles_allowed.total +
    //       invoice.data.total_tm.total +
    //       invoice.data.collision_damage_waiver.total +
    //       invoice.data.options_total.total +
    //       invoice.data.sub_total.total
    // );

    // const [invoiceTotalState, setInvoiceTotalState] = useState(
    //    Number(invoiceTotal)
    // );

    // Mock data for demonstration
    useEffect(() => {
        setUsers([]);
        setDatasUsers([]);
    }, []);

    useEffect(() => {
        setReserveNum([]);
    }, []);

    useEffect(() => {
        setCars([]);
        setCarData([]);
    }, []);

    // useEffect(() => firestore.collection('Users').onSnapshot((snapshot) => {
    //     const postData = [];
    //     // setUsers([]);
    //     snapshot.forEach((doc) => {
    //         setUsers((prev) => [...prev, doc.data()]);
    //         postData.push({ ...doc.data(), id: doc.id });
    //     });
    //     setDatasUsers(postData);
    // }), []);

    // useEffect(() => firestore.collection('Stat').onSnapshot((snapshot) => {
    // // const postData = [];
    //     setReserveNum([]);
    //     snapshot.forEach((doc) => {
    //         setReserveNum((prev) => [...prev, doc.data()]);
    //         //   postData.push({ ...doc.data(), id: doc.id });
    //     });
    // // setDatas(postData);
    // }), []);

    // useEffect(() => firestore.collection('Cars').onSnapshot((snapshot) => {
    //     const postData = [];
    //     setCars([]);
    //     snapshot.forEach((doc) => {
    //         setCars((prev) => [...prev, doc.data()]);
    //         //   postData.push({ ...doc.data(), id: doc.id });
    //     });
    //     setCarData(postData);
    // }), []);

    function selectAllCheckboxes() {
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        for (let i = 0; i < checkboxes.length; i += 1) {
            checkboxes[i].checked = true;
        }
    }

    // fetch test data
    // const testSubmit = async (id) => {
    //     // setIsSubmit(true);
    //     try {
    //         const response = await axios.post(
    //             "https://softcar-chrentacar-test-43b9adc2e8ec.herokuapp.com/checkout-session",
    //             {
    //                 customerID: "cus_Nal8W0CqJ4uDLg",
    //                 amount: amount * 100,
    //                 resID: id,
    //             },
    //         );
    //         console.log(response.data);
    //         window.location.href = `${response.data}`;
    //         setIsSubmit(false);
    //     } catch (err) {
    //         console.log(err.message);
    //         setError(err.message);
    //         setIsSubmit(false);
    //     }
    // };

    function deselectAllCheckboxes() {
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        for (let i = 0; i < checkboxes.length; i += 1) {
            checkboxes[i].checked = false;
        }
    }

    // const insFileChange = (e) => {
    //     if (
    //         e.target.files[0] &&
    //         (e.target.files[0].type === "application/pdf" ||
    //             e.target.files[0].type === "image/jpeg" ||
    //             e.target.files[0].type === "image/jpg" ||
    //             e.target.files[0].type === "image/png")
    //     ) {
    //         setInsFile(e.target.files[0]);
    //     }
    // };

    // const [totalAmount, setTotalAmount] = useState(0);

    const [dateDiff, setDateDiff] = useState(0);
    const [milesAllowed, setMilesAllowed] = useState();

    useEffect(() => {
        if (dateDiff) {
            setMilesAllowed(250 * dateDiff);
        }
    }, [dateDiff]);

    useEffect(() => {
        setAmount(
            mainInvoice?.reduce((n, { total }) => n + total, 0)
                ? mainInvoice?.reduce((n, { total }) => n + total, 0)
                : 0,
        );
    }, [mainInvoice]);

    const reserveForm = useFormik({
        initialValues: {
            UID: `${datasUsers[index]?.id ? datasUsers[index]?.id : ""}`,
            amount: 0,
            // amount: `${mainInvoice?.reduce(
            //    (n, { total }) => n + total,
            //    0
            // ) ? (mainInvoice?.reduce(
            //    (n, { total }) => n + total,
            //    0)): ""}`,
            // `carImages` removed: the backend replaced it with `checkIn` / `checkOut`, which are
            // captured at check-in on the booking site, not when an admin creates the reservation.
            image: cars[carIndex]?.images?.image1,
            carLinked: [
                {
                    id: cars[carIndex]?.id,
                    name: cars[carIndex]?.carName,
                },
            ],
            carSelected: {
                id: cars[carIndex]?.id,
                name: cars[carIndex]?.carName,
                serialNumber: cars[carIndex]?.serialNumber,
            },
            ongoing: false,
            carType: `${cars[carIndex]?.bodyType ? cars[carIndex]?.bodyType : ""}`,
            carName: `${cars[carIndex]?.carName ? cars[carIndex]?.carName : ""}`,
            customerName: `${users[index]?.name ? users[index]?.name : ""}`,
            dropoffDate: "",
            fcmToken: "",
            isASAP: false,
            isApproved: true,
            isCancelled: false,
            isCarDroppedOff: false,
            isCarLinked: true,
            isCarPickedUp: false,
            isCarSelected: true,
            isPaid: false,
            isRejected: false,
            package: 5.5,
            pickupDate: "",
            pickupLocation: {
                lat: "",
                lon: "",
                name: "",
            },
            creditCard: {
                front: "",
                back: "",
            },
            additionalDriver: {
                name: "",
                license: {
                    number: "",
                    issueDate: "",
                    expDate: "",
                    img: "",
                },
            },
            discount: {
                amount: null,
                reason: "",
            },
            milesAllowed: "",
            locationPickup: "",
            pickupReady: true,
            company: "",
            reason: "",
            showEditButton: false,
            showEndReservation: true,
            showStartReservation: false,
            showUnlockDoor: false,
            rentalMethod: "",
            customerNote: "",
            memo: "",
            language: "",
            rates: {
                daily: 25,
                hourly: 10,
            },
            serialID: `${(reserveNum[1]?.total || 0) + 1 ? (reserveNum[1]?.total || 0) + 1 : ""}`,
            unlockTime: null,
            invoice: [],
            email: `${users[index]?.email ? users[index]?.email : ""}`,
            mobileNumber: `${users[index]?.mobileNumber ? users[index]?.mobileNumber : ""}`,
        },
        onSubmit: (values) => {
            const formValues = { ...values };
            formValues.invoice = mainInvoice;
            formValues.amount = amount;
            formValues.creditCard.front = front;
            formValues.creditCard.back = back;
            formValues.additionalDriver.license.img = additionalImg;
            formValues.milesAllowed = milesAllowed;
            // Convert date strings to Date objects
            formValues.pickupDate = new Date(values.pickupDate);
            formValues.dropoffDate = new Date(values.dropoffDate);
            formValues.additionalDriver.license.issueDate = new Date(values.additionalDriver.license.issueDate);
            formValues.additionalDriver.license.expDate = new Date(values.additionalDriver.license.expDate);

            formValues.discount.amount = Number.parseInt(discountAmount, 10);

            if (
                formValues.serialID !== "" &&
                formValues.customerName !== "" &&
                formValues.email !== "" &&
                formValues.phone !== "" &&
                formValues.carType !== "" &&
                formValues.carName !== "" &&
                formValues.pickupDate !== "" &&
                formValues.dropoffDate !== "" &&
                formValues.pickupLocation.name !== "" &&
                formValues.company !== "" &&
                (formValues.creditCard.front !== "" || formValues.creditCard.back !== "") &&
                formValues.additionalDriver.license.img !== ""
                //  values.discount  !== "" &&
                //  values.reason !== "" &&
                // values.customerNote !== "" &&
                //  values.memo !== "" &&
                // values.language !== ""
            ) {
                setIsSubmit(true);
                // firestore
                //     .collection('Reservations')
                //     .add(values)
                //     .then((res) => {
                //         firestore
                //             .collection('Users')
                //             .doc(values.UID)
                //             .update({ requestID: res.id })
                //             .then(() => {
                //                 firestore
                //                     .collection('Users')
                //                     .doc(values.UID)
                //                     .update({
                //                         reservationID: firebase.firestore.FieldValue.arrayUnion(
                //                             res.id,
                //                         ),
                //                     })
                //                     .then(() => {
                //                         firestore
                //                             .collection('Users')
                //                             .doc(values.UID)
                //                             .collection('Scheduled Rides')
                //                             .doc(res.id)
                //                             .set(values)
                //                             .then(() => {
                //                                 firestore
                //                                     .collection('Stat')
                //                                     .doc('Reservations')
                //                                     .update({
                //                                         total: firebase.firestore.FieldValue.increment(1),
                //                                     });
                //                                 testSubmit(res.id);
                //                             });
                //                     });
                //             });
                //     });

                // setProceed(true);
                // setStoreData(formValues);

                //  setTotalAmount(invoice?.reduce(
                //    (n, { total }) => n + total,
                //    0
                // ) +
                //    invoice1?.reduce(
                //       (n, { total }) => n + total,
                //       0
                //    ))
            }
            // else if (picUploading1 || picUploading2) {
            //   setError("Please wait and try again after the upload is complete.");
            //   setLoading(false);
            // }
            //   else if (values.discount === "") {
            //     setError("Discount is required!");
            //  }
            //   else if (values.reason === "") {
            //     setError("Reason is required!");
            //  }
            // else if (values.customerNote === "") {
            //   setError("Customer Note is required!");
            // }
            //   else if (values.memo === "") {
            //     setError("Memo detail is required!");
            //  }
            // else if (values.language === "") {
            //   setError("Language is required!");
            // }
        },
        enableReinitialize: true,
    });

    // };
    // const testSubmit = (id) => {
    //   fetch("${process.env.REACT_APP_BACKEND}/checkout-session", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: {
    //       customerID: "cus_Nal8W0CqJ4uDLg",
    //       amount: 2,
    //       resID: id,
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((data) => console.log(data))
    //     .catch((error) => console.error(error.message));
    // };

    // const testSubmit = () => {
    //   axios
    //     .get("${process.env.REACT_APP_BACKEND}/", )
    //     .then(function (response) {
    //       // handle success

    //       console.log(response);
    //       // window.location.href = `${response}`;
    //     })
    //     .catch(function (error) {
    //       // handle error
    //       console.log(error);
    //     })
    //     .then(function () {
    //       // always executed
    //     });
    // };

    const [weeks, setWeeks] = useState(0);
    const [days, setDays] = useState(0);

    // const options = {
    //     // passing the client secret obtained from the server
    //     clientSecret: "{{CLIENT_SECRET}}",
    // };

    useEffect(() => {
        setDateDiff(getDifferenceInDays(reserveForm.values.pickupDate, reserveForm.values.dropoffDate));
        setWeeks(Math.floor(dateDiff / 7));
        if (weeks > 0) {
            if (invoice.find((x) => x.charge === "Weekly")) {
                const idx = invoice.findIndex((x) => x.charge === "Weekly");
                if (invoice[idx].unit !== weeks) {
                    const temp = invoice;
                    temp.splice(idx, 1);

                    setInvoice([
                        ...temp,
                        {
                            charge: "Weekly",
                            unit: weeks,
                            rate: 10,
                            total: weeks * 10,
                        },
                    ]);
                }
            } else {
                const temp2 = invoice;

                setInvoice([
                    ...temp2,
                    {
                        charge: "Weekly",
                        unit: weeks,
                        rate: 10,
                        total: weeks * 10,
                    },
                ]);
            }
        }

        setDays(dateDiff % 7);

        if (days > 0) {
            if (invoice.find((x) => x.charge === "Daily")) {
                const idx2 = invoice.findIndex((x) => x.charge === "Daily");
                if (invoice[idx2].unit !== days) {
                    const temp3 = invoice;
                    temp3.splice(idx2, 1);

                    setInvoice([
                        ...temp3,
                        {
                            charge: "Daily",
                            unit: days,
                            rate: 5,
                            total: days * 5,
                        },
                    ]);
                }
            } else {
                const temp4 = invoice;

                setInvoice([
                    ...temp4,
                    {
                        charge: "Daily",
                        unit: days,
                        rate: 5,
                        total: days * 5,
                    },
                ]);
            }
        }
    }, [reserveForm.values.dropoffDate, reserveForm.values.pickupDate, weeks, dateDiff, invoice, days]);

    // console.log(dateDiff);

    // Get the modal
    const modal = document.getElementById("myModal");
    const modalOne = document.getElementById("myModalOne");
    const modalTwo = document.getElementById("myModalTwo");
    const modalThree = document.getElementById("myModalThree");

    // Get the button that opens the modal
    const btn = document.getElementById("myBtn");
    const btn1 = document.getElementById("myBtn1");
    const btn2 = document.getElementById("myBtn2");
    const btn3 = document.getElementById("myBtn3");

    // Get the <span> element that closes the modal
    const span = document.getElementsByClassName("close")[0];
    const spanOne = document.getElementsByClassName("closeOne")[0];
    const spanTwo = document.getElementsByClassName("closeTwo")[0];
    const spanThree = document.getElementsByClassName("closeThree")[0];

    // When the user clicks the button, open the modal
    function openModal() {
        modal.style.display = "block";
        btn.onclick();
    }
    function openModal1() {
        modalOne.style.display = "block";
        btn1.onclick();
    }
    function openModal2() {
        modalTwo.style.display = "block";
        btn2.onclick();
    }
    function openModal3() {
        modalThree.style.display = "block";
        btn3.onclick();
    }
    // btn.onclick = function () {
    //    modal.style.display = "block";
    // };

    // When the user clicks on <span> (x), close the modal
    function close() {
        modal.style.display = "none";
        span.onclick();
    }

    function closeOne() {
        modalOne.style.display = "none";
        spanOne.onclick();
    }
    function closeTwo() {
        modalTwo.style.display = "none";
        spanTwo.onclick();
    }

    function closeThree() {
        modalThree.style.display = "none";
        spanThree.onclick();
    }

    function disablePastDates() {
        const today = new Date();
        const datepicker = document.getElementById("datepicker");
        datepicker.setAttribute("min", today.toISOString().slice(0, 10));
    }

    function dateDisable() {
        // var todayDate = new Date();
        // var month = todayDate.getMonth(); //04 - current month
        // var year = todayDate.getUTCFullYear() - 18; //2021 - current year
        // var tdate = todayDate.getDate(); // 27 - current date
        // if (month < 10) {
        //     month = "0" + month //'0' + 4 = 04
        // }
        // if (tdate < 10) {
        //     tdate = "0" + tdate;
        // }
        // var maxDate = year + "-" + month + "-" + tdate;
        // document.getElementById("demo").setAttribute("max", maxDate);
        // console.log(maxDate);

        const date = new Date().toISOString();
        const newStr = date.substring(0, date.length - 14);

        const newStr2 = `${newStr}T00:00:00.000`;
        // console.log(newStr2)
        return newStr2;
    }
    function dateDisable1() {
        // var todayDate = new Date();
        // var month = todayDate.getMonth(); //04 - current month
        // var year = todayDate.getUTCFullYear() - 18; //2021 - current year
        // var tdate = todayDate.getDate(); // 27 - current date
        // if (month < 10) {
        //     month = "0" + month //'0' + 4 = 04
        // }
        // if (tdate < 10) {
        //     tdate = "0" + tdate;
        // }
        // var maxDate = year + "-" + month + "-" + tdate;
        // document.getElementById("demo").setAttribute("max", maxDate);
        // console.log(maxDate);

        const date = new Date().toISOString();
        const newStr = date.substring(0, date.length - 14);

        const newStr2 = `${newStr}T00:00:00.000`;
        // console.log(newStr2)
        return newStr2;
    }
    // span.onclick = function () {

    // };

    // // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {
    //    if (event.target == modal) {
    //       modal.style.display = "none";
    //    }
    // };

    return (
        <form
            // eslint-disable-next-line react/no-unknown-property
            onLoad={() => {
                disablePastDates();
            }}>
            {/* <RingSpinner loading={isSubmit} size={28} /> */}

            {isSubmit ? (
                <div className="loader">
                    <Oval
                        height={80}
                        width={80}
                        color="#4fa94d"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            ) : (
                ""
            )}

            {/* <!-- The Modal For Vehicle --> */}
            <div id="myModal" className="modal">
                {/*   <!-- Modal content --> */}
                <div className="modal-content">
                    <span onClick={() => close()} className="close">
                        &times;
                    </span>
                    <div>
                        <div
                            style={{
                                marginTop: "38px",
                                marginLeft: "202.2px",
                            }}>
                            <h1 className="vehicle-search">Vehicle search</h1>
                        </div>

                        <div
                            style={{
                                display: "grid",
                                marginLeft: "202.2px",
                                gridTemplateColumns: "repeat(2, 45%)",
                            }}>
                            <div>
                                <div>
                                    <h1 className="name-style1">Assigned ID</h1>
                                    <input className="vehicle-search-input" type="text" name="" id="" />
                                </div>
                                <div
                                    style={{
                                        marginTop: "20px",
                                    }}>
                                    <h1 className="name-style1">License Plate</h1>
                                    <input className="vehicle-search-input" type="text" name="" id="" />
                                </div>
                                <div
                                    style={{
                                        marginTop: "20px",
                                    }}>
                                    <h1 className="name-style1">Vehicle Type</h1>
                                    <div>
                                        <select className="vehicle-search-input1">
                                            <option value="" selected disabled hidden />
                                            <option value="volvo">Volvo</option>
                                            <option value="saab">Saab</option>
                                            <option value="opel">Opel</option>
                                            <option value="audi">Audi</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <h1 className="name-style1">Location</h1>
                                    <div>
                                        <select name="cars" className="vehicle-search-input1" required>
                                            <option value="" selected disabled hidden>
                                                Select Location
                                            </option>
                                            <option value="volvo">Volvo</option>
                                            <option value="saab">Saab</option>
                                            <option value="opel">Opel</option>
                                            <option value="audi">Audi</option>
                                        </select>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        marginTop: "20px",
                                    }}>
                                    <h1 className="name-style1">Owing Location</h1>
                                    <div>
                                        <select name="cars" className="vehicle-search-input1" id="cars" required>
                                            <option value="" selected disabled hidden>
                                                Select Location
                                            </option>
                                            <option value="volvo">Volvo</option>
                                            <option value="saab">Saab</option>
                                            <option value="opel">Opel</option>
                                            <option value="audi">Audi</option>
                                        </select>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        marginTop: "20px",
                                    }}>
                                    <h1 className="name-style1">Current Location</h1>
                                    <select name="cars" className="vehicle-search-input1" required>
                                        <option value="" selected disabled hidden>
                                            Select Location
                                        </option>
                                        <option value="volvo">Volvo</option>
                                        <option value="saab">Saab</option>
                                        <option value="opel">Opel</option>
                                        <option value="audi">Audi</option>
                                    </select>
                                </div>

                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ flex: "1" }} />
                                    <div
                                        style={{
                                            marginTop: "1.5rem",
                                            // paddingLeft: "60.5rem",
                                            marginRight: "3.5rem",
                                            cursor: "pointer",
                                        }}
                                        className="search-button">
                                        {<span className="search-text">Search</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Table */}
                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "scroll",
                            height: "41%",
                            marginTop: "20px",
                            border: "1px solid #DFDFFF",
                        }}>
                        <table
                            style={{
                                overflowX: "auto",
                                overflowY: "scroll",
                                borderCollapse: "collapse",
                                borderSpacing: "0",
                                width: "100%",

                                border: "1px solid #DFDFFF",
                            }}
                            className="sticky-style sc-table">
                            <tr
                                style={{
                                    width: "100%",
                                    height: "57px",

                                    background: "#00004C",
                                }}
                                className="vehicle-table">
                                <th>Vehicle ID</th>
                                <th>Type</th>
                                <th>Current Location</th>
                                <th>Colour</th>
                                <th>Model</th>
                                <th>Plate</th>
                                <th>Odometer</th>
                                <th>Fuel</th>
                                <th>Status</th>
                            </tr>
                            {cars.map((car, carIdx) => (
                                <>
                                    <tr
                                        style={{
                                            width: "100%",
                                            height: "57px",
                                            cursor: "pointer",
                                            background: "#ffffff",
                                        }}
                                        onClick={() => {
                                            setCarIndex(carIdx);
                                            close();
                                        }}>
                                        <th className="vehicle-table-row-data">{car?.VIN}</th>

                                        <th className="vehicle-table-row-data">{car?.bodyType}</th>
                                        <th className="vehicle-table-row-data">{car?.registration?.state}</th>
                                        <th className="vehicle-table-row-data">{car?.config?.color}</th>
                                        <th className="vehicle-table-row-data">{car?.config?.model}</th>
                                        <th className="vehicle-table-row-data">N/A</th>
                                        <th className="vehicle-table-row-data">
                                            {/* 134113 */}
                                            N/A
                                        </th>
                                        <th className="vehicle-table-row-data">{car?.fuelType}</th>
                                        <th className="vehicle-table-row-data">{car?.status}</th>
                                    </tr>
                                </>
                            ))}
                        </table>
                    </div>
                </div>
            </div>

            {/* Customer Search */}
            <div id="myModalOne" className="modal">
                {/*   <!-- Modal content --> */}
                <div className="modal-content">
                    <span onClick={() => closeOne()} className="closeOne">
                        &times;
                    </span>
                    <div>
                        <div
                            style={{
                                marginTop: "38px",
                                marginLeft: "202.2px",
                            }}>
                            <h1 className="vehicle-search">Customer search</h1>
                        </div>
                        <div
                            style={{
                                display: "grid",
                                marginLeft: "202.2px",
                                gridTemplateColumns: "repeat(2, 45%)",
                            }}>
                            <div>
                                <div>
                                    <h1 className="name-style1">First Name</h1>
                                    <input className="vehicle-search-input" type="text" name="" id="" required />
                                </div>
                                <div
                                    style={{
                                        marginTop: "20px",
                                    }}>
                                    <h1 className="name-style1">Last Name</h1>
                                    <input className="vehicle-search-input" type="text" name="" id="" required />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <h1 className="name-style1">Driving License</h1>
                                    <div>
                                        <input className="vehicle-search-input" type="text" name="" id="" required />
                                    </div>
                                </div>
                                <div
                                    style={{
                                        marginTop: "20px",
                                    }}>
                                    <h1 className="name-style1">Email</h1>
                                    <div>
                                        <input className="vehicle-search-input" type="text" name="" id="" />
                                    </div>
                                </div>

                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ flex: "1" }} />
                                    <div
                                        style={{
                                            marginTop: "1.5rem",
                                            // paddingLeft: "60.5rem",
                                            marginRight: "3.5rem",
                                            cursor: "pointer",
                                        }}
                                        className="search-button">
                                        {<span className="search-text">Search</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Table */}
                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "scroll",
                            height: "53%",
                            marginTop: "28px",
                            border: "1px solid #DFDFFF",
                        }}>
                        <table
                            style={{
                                overflowX: "auto",
                                overflowY: "scroll",
                                borderCollapse: "collapse",
                                borderSpacing: "0",
                                width: "100%",
                            }}
                            className="sticky-style sc-table">
                            <tr
                                style={{
                                    width: "100%",
                                    height: "57px",
                                    background: "#00004C",
                                }}
                                className="vehicle-table">
                                <th>First Name</th>
                                <th>Company Name</th>
                                <th>Phone</th>
                                <th>City</th>
                                <th>State</th>
                            </tr>

                            {users?.map((customer, customerIndex) => (
                                <>
                                    <tr
                                        style={{
                                            width: "100%",
                                            height: "57px",
                                            cursor: "pointer",

                                            background: "#ffffff",
                                        }}
                                        onClick={() => {
                                            setIndex(customerIndex);
                                            closeOne();
                                        }}>
                                        <th className="vehicle-table-row-data">{customer?.name}</th>

                                        <th className="vehicle-table-row-data">N/A</th>
                                        <th className="vehicle-table-row-data">{customer?.mobileNumber}</th>
                                        <th className="vehicle-table-row-data">N/A</th>
                                        <th className="vehicle-table-row-data">N/A</th>
                                    </tr>
                                </>
                            ))}
                        </table>
                    </div>
                </div>
            </div>

            {/* Add Other Charges Model */}
            <div id="myModalTwo" className="modal">
                {/*   <!-- Modal content --> */}
                <div className="modal-content1">
                    <span onClick={() => closeTwo()} className="closeTwo">
                        &times;
                    </span>
                    <div>
                        <div
                            style={{
                                marginTop: "25px",
                                marginLeft: "70px",
                                marginBottom: "40px",
                            }}>
                            <h1 className="vehicle-search">Add Other Charges</h1>
                        </div>
                        <div
                            style={{
                                display: "grid",
                                marginLeft: "70px",
                                gridTemplateColumns: "repeat(2, 45%)",
                            }}>
                            <div>
                                <div
                                    style={{
                                        marginBottom: "20px",
                                    }}>
                                    <h1
                                        className="name-style1"
                                        style={{
                                            display: "inline-block",
                                            marginRight: "8px",
                                        }}>
                                        Amount
                                    </h1>
                                    <input
                                        className="add-charge-amount"
                                        type="number"
                                        name=""
                                        id=""
                                        required
                                        style={{ display: "inline-block" }}
                                        value={inputValue}
                                        onChange={handleChange}
                                    />
                                    <h1 className="amount-percent" style={{ marginLeft: "8px" }}>
                                        +11.5%
                                    </h1>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <h1 className="name-style1" style={{ display: "inline" }}>
                                        Detail
                                    </h1>
                                    <span style={{ display: "inline", marginRight: "8px" }} className="star">
                                        *
                                    </span>
                                    <div style={{ display: "inline-block" }}>
                                        <input
                                            className="detail-input"
                                            type="text"
                                            name=""
                                            id=""
                                            required
                                            value={inputValue1}
                                            onChange={handleChange1}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ flex: "1" }} />
                                    <div
                                        style={{
                                            marginTop: "1.5rem",
                                            // paddingLeft: "60.5rem",
                                            marginRight: "0.5rem",
                                            cursor: "pointer",
                                        }}
                                        className="search-button"
                                        onClick={() => {
                                            if (inputValue && inputValue1) {
                                                setInvoice1((prev) => [
                                                    ...prev,
                                                    {
                                                        charge: `${inputValue1}`,

                                                        rate: `${inputValue}`,
                                                        total: dateDiff * `${inputValue}`,
                                                    },
                                                ]);
                                                setInputValue("");
                                                setInputValue1("");
                                                closeTwo();
                                            } else {
                                                const arr = invoice1;
                                                const ind = arr.findIndex((n) => n.charge === `${inputValue1}`);
                                                arr.splice(ind, 1);
                                                setInvoice1(arr);
                                                setRerender(render + 1);
                                            }
                                        }}>
                                        {
                                            <span className="fontRegular" style={{ color: "white" }}>
                                                Add
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Other Charges Model */}

            <div id="myModalThree" className="modal">
                {/*   <!-- Modal content --> */}
                <div className="modal-content1">
                    <span onClick={() => closeThree()} className="closeThree">
                        &times;
                    </span>
                    <div>
                        <div
                            style={{
                                marginTop: "25px",
                                marginLeft: "10px",
                                marginBottom: "40px",
                            }}>
                            <h1 className="vehicle-search">Edit Other Charges</h1>
                        </div>
                        <div
                            style={{
                                display: "grid",
                                marginLeft: "10px",
                                gridTemplateColumns: "repeat(1, auto)",
                            }}>
                            <div
                                style={{
                                    overflowX: "auto",
                                    overflowY: "scroll",
                                    height: "290px",
                                    marginTop: "-25px",
                                    border: "1px solid #DFDFFF",
                                }}>
                                <table
                                    style={{
                                        overflowX: "auto",
                                        overflowY: "scroll",
                                        borderCollapse: "collapse",
                                        borderSpacing: "0",
                                        width: "100%",
                                    }}
                                    className="sticky-style sc-table">
                                    <tr
                                        style={{
                                            width: "100%",
                                            height: "57px",
                                            background: "#00004C",
                                        }}
                                        className="vehicle-table">
                                        <th>Charge</th>
                                        <th>Rate</th>
                                        <th>Total</th>
                                        <th>Action</th>
                                    </tr>

                                    {invoice1?.map((charges, chargeIndex) => (
                                        <>
                                            <tr
                                                style={{
                                                    width: "100%",
                                                    height: "57px",
                                                    cursor: "pointer",

                                                    background: "#ffffff",
                                                }}
                                                onClick={() => {
                                                    setIndex(chargeIndex);
                                                    closeOne();
                                                }}>
                                                <th className="vehicle-table-row-data">{charges?.charge}</th>

                                                <th className="vehicle-table-row-data">{charges?.rate}</th>
                                                <th className="vehicle-table-row-data">{charges?.total}</th>
                                                <th
                                                    className="vehicle-table-row-data"
                                                    onClick={() => {
                                                        const arr = invoice1;
                                                        const ind = arr.findIndex(
                                                            (n) => n.charge === `${charges?.charge}`,
                                                        );
                                                        arr.splice(ind, 1);
                                                        setInvoice1(arr);
                                                        setRerender(render + 1);
                                                    }}>
                                                    <img width="18px" alt="" src={trash} />{" "}
                                                </th>
                                            </tr>
                                        </>
                                    ))}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="min-h-[520px] flex flex-1 flex-col justify-evenly">
                <div
                    className="text-[1.2rem] fontbold"
                    style={{
                        // paddingTop: "1rem",

                        // paddingLeft: "1.6rem",
                        // paddingRight: "1.6rem",
                        borderRadius: "1.6rem",
                        marginBottom: "-1rem",
                        // marginTop: "0.7rem",
                    }}>
                    Make Reservation
                </div>

                <p style={{ color: "red" }}> {} </p>

                <div style={{ overflowY: "scroll" }}>
                    {/* <div className="container-style">
                  <div></div>
                  <div></div>
                  <div>
                     <div
                        className="fontLight"
                        style={{ display: "inline-block" }}
                     >
                        Reservation:&nbsp;
                     </div>
                     <span
                        className="fontbold"
                        style={{
                           fontSize: "1.1rem",
                        }}
                     >
                        06 January, 2023
                     </span>
                     <div className="border-style"></div>
                  </div>
                  <div>
                     <div
                        className="fontbold"
                        style={{
                           fontSize: "1.1rem",
                        }}
                     >
                        Vehicle Information
                     </div>
                     <div className="border-style"></div>
                  </div>
                  <div>
                     <div
                        className="fontbold"
                        style={{
                           fontSize: "1.1rem",
                        }}
                     >
                        Update Charges Summary
                     </div>
                     <div className="border-style2"></div>
                  </div>
               </div> */}

                    <div className="container-style">
                        {/* Customer Information */}

                        <div className="customer-information-reservation">
                            <div>
                                <div className="fontLight" style={{ display: "inline-block" }}>
                                    Reservation:&nbsp;
                                </div>
                                <span
                                    className="fontbold"
                                    style={{
                                        fontSize: "1.1rem",
                                    }}>
                                    06 January, 2023
                                </span>
                                <div className="border-style" />
                            </div>
                            <div
                                style={{
                                    marginBottom: "1rem",
                                    marginTop: "-1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Reservation
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />
                                <input
                                    className="input-style"
                                    type="text"
                                    required
                                    value={reserveForm.values.serialID}
                                    onChange={reserveForm.handleChange}
                                    name="serialID"
                                    disabled
                                />
                            </div>
                            <div
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Customer name
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />

                                <div style={{ position: "relative" }}>
                                    <input
                                        className="input-style"
                                        type="text"
                                        disabled
                                        // style={{
                                        //    display: "inline",
                                        // }}
                                        value={reserveForm.values.customerName}
                                        onChange={reserveForm.handleChange}
                                        name="customerName"
                                    />
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <div style={{ flex: "1" }} />
                                        <div
                                            style={{
                                                marginTop: "-25px",
                                                marginLeft: "50px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => openModal1()}
                                            id="myBtn1">
                                            <img src={search} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Email
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />
                                <input
                                    className="input-style"
                                    type="email"
                                    disabled
                                    value={reserveForm.values.email}
                                    onChange={reserveForm.handleChange}
                                    name="email"
                                />
                            </div>
                            <div>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Phone
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />
                                <input
                                    className="input-style"
                                    type="number"
                                    value={reserveForm.values.mobileNumber}
                                    onChange={reserveForm.handleChange}
                                    name="mobileNumber"
                                />
                            </div>
                        </div>
                        {/* Vehicle Information */}

                        <div>
                            <div className="vehicle-information1">
                                <div>
                                    <div
                                        className="fontbold"
                                        style={{
                                            fontSize: "1.1rem",
                                        }}>
                                        Vehicle Information
                                    </div>
                                    <div className="border-style" />
                                </div>
                                <div
                                    style={{
                                        marginBottom: "1rem",
                                    }}>
                                    <div
                                        className="fontRegular"
                                        style={{
                                            display: "inline-block",
                                        }}>
                                        Vehicle
                                    </div>
                                    <span style={{ color: "red", display: "inline-block" }}>*</span>
                                    <br />
                                    <div>
                                        <input
                                            type="text"
                                            className="input-style"
                                            style={{
                                                padding: "2.5px",
                                            }}
                                            value={reserveForm.values.carType}
                                            onChange={reserveForm.handleChange}
                                            name="carType"
                                            disabled
                                        />

                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <div style={{ flex: "1" }} />
                                            <div
                                                style={{
                                                    marginTop: "-28px",
                                                    marginLeft: "50px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => openModal()}
                                                id="myBtn">
                                                <img src={search} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div
                  style={{
                    marginBottom: "1rem",
                  }}
                >
                  <div
                    className="fontRegular"
                    style={{
                      display: "inline-block",
                    }}
                  >
                    Rate
                  </div>
                  <span style={{ color: "red", display: "inline-block" }}>
                    *
                  </span>
                  <br />
                  <input
                    type="text"
                    name="inspection.last"
                    className="input-style"
                    style={{
                      padding: "2.5px",
                    }}
                    disabled
                  />
                </div> */}

                                <div>
                                    <div
                                        className="fontRegular"
                                        style={{
                                            display: "inline-block",
                                        }}>
                                        Vehicle type
                                    </div>
                                    {/* <span style={{ color: "red", display: "inline-block" }}>
                           *
                        </span> */}
                                    <br />
                                    <input
                                        className="input-style"
                                        type="text"
                                        required
                                        value={reserveForm.values.carName}
                                        onChange={reserveForm.handleChange}
                                        name="carName"
                                        // style={{
                                        //    display: "inline",
                                        // }}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Invoice */}
                        <div className="updates-charges-summary">
                            <div
                                style={{
                                    paddingTop: "7px",
                                    paddingLeft: "18px",
                                    paddingRight: "18px",
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    //   justifyContent: "space-around"
                                }}>
                                <div>
                                    <div className="fontbold">Charge</div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                    <div>
                                        <div className="fontbold">Unit</div>
                                    </div>
                                    <div>
                                        <div className="fontbold">Rate</div>
                                    </div>
                                    <div>
                                        <div className="fontbold">Total</div>
                                    </div>
                                </div>
                            </div>
                            <hr className="border-style1" />

                            {invoice.map((invoiceItem) => (
                                <>
                                    <div
                                        style={{
                                            // paddingTop: "7px",
                                            paddingLeft: "18px",
                                            paddingRight: "18px",
                                            display: "grid",
                                            gridTemplateColumns: "repeat(2, 1fr)",
                                            //   justifyContent: "space-around"
                                        }}>
                                        <div>
                                            <div className="fontRegular" style={{ marginBottom: "1.5rem" }}>
                                                {invoiceItem.charge}
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginBottom: "1.5rem",
                                            }}>
                                            <div>
                                                <div className="fontRegular">{invoiceItem.unit}</div>
                                            </div>
                                            <div>
                                                <div className="fontRegular">${invoiceItem.rate}</div>
                                            </div>
                                            <div>
                                                <div className="fontRegular">${invoiceItem.total}</div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}
                            <>
                                <div
                                    style={{
                                        // paddingTop: "7px",
                                        paddingLeft: "18px",
                                        paddingRight: "18px",
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, 1fr)",
                                        marginBottom: "1.4rem",
                                        //   justifyContent: "space-around"
                                    }}>
                                    <div>
                                        <div className="fontRegular">Miles Allowed</div>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}>
                                        <div>
                                            <div className="fontRegular">{250 * dateDiff}</div>
                                        </div>
                                        <div>
                                            <div className="fontRegular" />
                                        </div>
                                        <div>
                                            <div className="fontRegular" />
                                        </div>
                                    </div>
                                </div>
                            </>

                            <>
                                <div
                                    style={{
                                        // paddingTop: "7px",
                                        paddingLeft: "18px",
                                        paddingRight: "18px",
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, 1fr)",
                                        //   justifyContent: "space-around"
                                    }}>
                                    <div>
                                        <div className="fontRegular">Total T&M</div>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}>
                                        <div>
                                            <div className="fontRegular" />
                                        </div>
                                        <div>
                                            <div className="fontRegular" />
                                        </div>
                                        {}

                                        <>
                                            <div>
                                                <div className="fontRegular">
                                                    ${invoice?.reduce((n, { total }) => n + total, 0)}
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </div>
                            </>
                            {invoice1.map((data) => (
                                <>
                                    <div
                                        style={{
                                            paddingTop: "18px",
                                            paddingLeft: "18px",
                                            paddingRight: "18px",
                                            display: "grid",
                                            gridTemplateColumns: "repeat(2, 1fr)",
                                            //   justifyContent: "space-around"
                                        }}>
                                        <div>
                                            <div className="fontRegular">{data.charge}</div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}>
                                            <div>
                                                <div className="fontRegular" />
                                            </div>
                                            <div>
                                                <div className="fontRegular">${data?.rate}</div>
                                            </div>
                                            <div>
                                                <div className="fontRegular">${data.total}</div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}

                            <div
                                style={{
                                    paddingTop: "18px",
                                    paddingLeft: "18px",
                                    paddingRight: "18px",
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    //   justifyContent: "space-around"
                                }}>
                                <div>
                                    <div className="fontRegular">Options total</div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular">
                                            ${invoice1?.reduce((n, { total }) => n + total, 0)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    paddingTop: "18px",
                                    paddingLeft: "18px",
                                    paddingRight: "18px",
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    //   justifyContent: "space-around"
                                }}>
                                <div>
                                    <div className="fontRegular">Discount</div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular">${`${discountAmount || 0}`}</div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    paddingTop: "18px",
                                    paddingLeft: "18px",
                                    paddingRight: "18px",
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    //   justifyContent: "space-around"
                                }}>
                                <div>
                                    <div className="fontRegular">Total</div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular">
                                            $
                                            {(() => {
                                                const invoiceTotal =
                                                    invoice && Array.isArray(invoice)
                                                        ? invoice.reduce((n, { total }) => n + (total || 0), 0)
                                                        : 0;
                                                const invoice1Total =
                                                    invoice1 && Array.isArray(invoice1)
                                                        ? invoice1.reduce((n, { total }) => n + (total || 0), 0)
                                                        : 0;
                                                const discount = discountAmount || 0;

                                                return discountAmount
                                                    ? invoiceTotal + invoice1Total - discount
                                                    : invoiceTotal + invoice1Total;
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    paddingTop: "18px",
                                    paddingLeft: "18px",
                                    paddingRight: "18px",
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    //   justifyContent: "space-around"
                                }}>
                                <div>
                                    <div className="fontRegular">Deposit</div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular"></div>
                                    </div>
                                    <div>
                                        <div className="fontRegular">
                                            $
                                            {discountAmount
                                                ? invoice?.reduce((n, { total }) => n + total, 0) +
                                                  invoice1?.reduce((n, { total }) => n + total, 0) -
                                                  discountAmount
                                                : invoice?.reduce((n, { total }) => n + total, 0) +
                                                  invoice1?.reduce((n, { total }) => n + total, 0)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Date and Locations */}
                        <div
                            className="date-location-information"
                            style={{
                                marginTop: "40px",
                            }}>
                            <div className="fontbold" style={{ fontSize: "1.1rem" }}>
                                Date & Locations
                            </div>
                            <div className="border-style-date-location"></div>

                            <div
                                // style={{
                                //    paddingTop: "20px",
                                // }}
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Pickup Date
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />
                                <input
                                    type="datetime-local"
                                    name="pickupDate"
                                    id="demo"
                                    // min={new Date().toLocaleString().substring(0, new Date().toLocaleString().length -1)}
                                    // min={`Sat Apr 01 2023`}
                                    min={dateDisable()}
                                    // min="2023-04-01T00:00:00"
                                    pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}"
                                    value={reserveForm.values.pickupDate}
                                    onChange={reserveForm.handleChange}
                                    className="input-style"
                                    style={{
                                        padding: "2.5px",
                                        cursor: "pointer",
                                    }}
                                    // onBlur={()=>{
                                    //   dateDisable();
                                    // }}
                                />
                                {/* <DatePicker
                  // selected={date}
                  className="input-style"
                  value={reserveForm.values.pickupDate}
                  onChange={reserveForm.handleChange}
                  showTimeSelect
                  dateFormat="Pp"
                  style={{
                    padding: "2.5px",
                  }}
                /> */}
                            </div>
                            <div
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Drop Off Date
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />
                                <div>
                                    <input
                                        type="datetime-local"
                                        name="dropoffDate"
                                        min={dateDisable1()}
                                        value={reserveForm.values.dropoffDate}
                                        onChange={reserveForm.handleChange}
                                        className="input-style"
                                        style={{
                                            padding: "2.5px",
                                            cursor: "pointer",
                                        }}
                                    />
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    paddingTop: "1rem",
                                    marginBottom: "1rem",
                                }}>
                                <div>
                                    <div
                                        className="fontRegular"
                                        style={{
                                            display: "inline-block",
                                        }}>
                                        Days
                                    </div>
                                </div>
                                <div>
                                    <input
                                        className="days-input"
                                        style={{
                                            textAlign: "center",
                                        }}
                                        type="number"
                                        defaultValue="0"
                                        value={dateDiff}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Pickup Location
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />
                                <div>
                                    <input
                                        type="text"
                                        className="input-style"
                                        style={{
                                            padding: "2.5px",
                                        }}
                                        name="pickupLocation.name"
                                        value={reserveForm?.values?.pickupLocation.name}
                                        onChange={reserveForm.handleChange}
                                    />
                                </div>
                            </div>
                            {/* <div
                        style={{
                           marginBottom: "1rem",
                        }}
                     >
                        <div
                           className="fontRegular"
                           style={{
                              display: "inline-block",
                           }}
                        >
                           Return Location
                        </div>
                        <span style={{ color: "red", display: "inline-block" }}>
                           *
                        </span>
                        <br />
                        <div>
                           <input
                              type="text"
                              name="inspection.last"
                              className="input-style"
                              style={{
                                 padding: "2.5px",
                              }}
                              required
                           />
                        </div>
                     </div> */}
                            <div
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Company
                                </div>
                                <span style={{ color: "red", display: "inline-block" }}>*</span>
                                <br />
                                <div>
                                    <input
                                        type="text"
                                        className="input-style"
                                        style={{
                                            padding: "2.5px",
                                        }}
                                        name="company"
                                        value={reserveForm.values.company}
                                        onChange={reserveForm.handleChange}
                                    />
                                </div>
                            </div>
                            <div
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Discount
                                </div>
                                {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                <br />
                                <div>
                                    <div>
                                        <input
                                            id="myInput"
                                            type="number"
                                            className="input-style"
                                            style={{
                                                padding: "2.5px",
                                            }}
                                            onBlur={() => {
                                                getInputValue();
                                            }}
                                            name="discount.amount"
                                            value={reserveForm.values.discount.parseI}
                                            onChange={reserveForm.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    marginBottom: "1rem",
                                }}>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Reason
                                </div>
                                {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                <br />
                                <div>
                                    <input
                                        type="text"
                                        className="input-style"
                                        style={{
                                            padding: "2.5px",
                                        }}
                                        name="discount.reason"
                                        value={reserveForm.values.discount.reason}
                                        onChange={reserveForm.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Others Information */}
                        <div
                            className="others-information-note-memo1"
                            style={{
                                marginTop: "40px",
                            }}>
                            <div
                                className="fontbold"
                                style={{
                                    display: "inline-block",
                                    fontSize: "1.1rem",
                                }}>
                                Others
                            </div>
                            <div className="border-style-others"></div>

                            <div
                            // style={{
                            //    paddingTop: "20px",
                            // }}
                            >
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Customer Note
                                </div>
                                {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                <br />
                                <textarea
                                    className="customer-note1"
                                    type="text"
                                    name="customerNote"
                                    value={reserveForm.values.customerNote}
                                    onChange={reserveForm.handleChange}
                                />
                            </div>
                            <div>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Memo
                                </div>
                                {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                <br />
                                <textarea
                                    className="customer-note1"
                                    type="text"
                                    name="memo"
                                    value={reserveForm.values.memo}
                                    onChange={reserveForm.handleChange}
                                />
                            </div>
                            <div>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                    }}>
                                    Language
                                </div>
                                {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                <br />
                                <div>
                                    <div>
                                        <input
                                            type="text"
                                            className="input-style"
                                            style={{
                                                padding: "2.5px",
                                            }}
                                            name="language"
                                            value={reserveForm.values.language}
                                            onChange={reserveForm.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Additionals */}
                        <div
                            className="others-information-note-memo2"
                            style={{
                                marginTop: "40px",
                            }}>
                            <div
                                className="fontbold"
                                style={{
                                    fontSize: "1.1rem",
                                }}>
                                Additionals
                            </div>
                            <div className="border-style-others"></div>

                            <div
                            // style={{
                            //    paddingTop: "20px",
                            // }}
                            >
                                <div
                                    className="fontRegular"
                                    style={
                                        {
                                            // display: "inline-block",
                                        }
                                    }>
                                    Do you want to add an additional driver?
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: "10px",
                                        marginBottom: "5px",
                                    }}>
                                    <div
                                        className="scancopybtn"
                                        onClick={() => {
                                            const butt1 = document.getElementById("insfile");
                                            butt1.click();
                                        }}>
                                        scan copy
                                    </div>
                                    <span
                                        style={{
                                            color: "#acacb9",
                                            marginLeft: "1rem",
                                            width: "50%",
                                        }}>
                                        {/* no file choosen */}
                                        <input
                                            type="file"
                                            id="insfile"
                                            accept="application/pdf"
                                            onChange={additionalInfo}
                                        />
                                    </span>
                                </div>

                                {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                            </div>
                            <div>
                                <div
                                    className="fontRegular"
                                    style={{
                                        marginTop: "5px",
                                    }}>
                                    Name
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        className="input-style"
                                        style={{
                                            padding: "2.5px",
                                        }}
                                        name="additionalDriver.name"
                                        value={reserveForm?.values?.additionalDriver?.name}
                                        onChange={reserveForm.handleChange}
                                    />
                                </div>
                            </div>
                            <div>
                                <div
                                    className="fontRegular"
                                    style={{
                                        marginTop: "10px",
                                    }}>
                                    License Number
                                </div>

                                <div>
                                    <input
                                        type="number"
                                        className="input-style"
                                        style={{
                                            padding: "2.5px",
                                        }}
                                        name="additionalDriver.license.number"
                                        value={reserveForm?.values?.additionalDriver?.license.number}
                                        onChange={reserveForm.handleChange}
                                    />
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    width: "50%",
                                    // justifyContent: "space-between",
                                    flexDirection: "row",
                                }}>
                                <div
                                    // style={{
                                    //    paddingTop: "20px",
                                    // }}
                                    style={{
                                        marginBottom: "1rem",

                                        width: "100%",
                                        flex: "1",
                                        display: "flex",
                                        flexDirection: "column",
                                        paddingRight: "0.5rem",
                                        // marginRight:"30px"
                                    }}>
                                    <div
                                        className="fontRegular"
                                        style={{
                                            marginTop: "10px",
                                        }}>
                                        Issue date
                                    </div>
                                    {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                    <br />
                                    <input
                                        type="datetime-local"
                                        name="additionalDriver.license.issueDate"
                                        id="demo"
                                        // min={new Date().toLocaleString().substring(0, new Date().toLocaleString().length -1)}
                                        // min={`Sat Apr 01 2023`}
                                        // min={dateDisable()}
                                        // min="2023-04-01T00:00:00"
                                        pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}"
                                        value={reserveForm.values.additionalDriver.license.issueDate}
                                        onChange={reserveForm.handleChange}
                                        className="license-issue"
                                        style={{
                                            padding: "2.5px",
                                            cursor: "pointer",
                                        }}
                                        // onBlur={()=>{
                                        //   dateDisable();
                                        // }}
                                    />
                                    {/* <DatePicker
                  // selected={date}
                  className="input-style"
                  value={reserveForm.values.pickupDate}
                  onChange={reserveForm.handleChange}
                  showTimeSelect
                  dateFormat="Pp"
                  style={{
                    padding: "2.5px",
                  }}
                /> */}
                                </div>

                                <div
                                    // style={{
                                    //    paddingTop: "20px",
                                    // }}
                                    style={{
                                        marginBottom: "1rem",
                                        width: "100%",
                                        flex: "1",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}>
                                    <div
                                        className="fontRegular"
                                        style={{
                                            marginTop: "10px",
                                        }}>
                                        Exp. date
                                    </div>
                                    {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                    <br />
                                    <input
                                        type="datetime-local"
                                        name="additionalDriver.license.expDate"
                                        id="demo"
                                        // min={new Date().toLocaleString().substring(0, new Date().toLocaleString().length -1)}
                                        // min={`Sat Apr 01 2023`}
                                        min={dateDisable()}
                                        // min="2023-04-01T00:00:00"
                                        pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}"
                                        value={reserveForm.values.additionalDriver.license.expDate}
                                        onChange={reserveForm.handleChange}
                                        className="license-issue"
                                        style={{
                                            padding: "2.5px",
                                            cursor: "pointer",
                                        }}
                                        // onBlur={()=>{
                                        //   dateDisable();
                                        // }}
                                    />
                                    {/* <DatePicker
                  // selected={date}
                  className="input-style"
                  value={reserveForm.values.pickupDate}
                  onChange={reserveForm.handleChange}
                  showTimeSelect
                  dateFormat="Pp"
                  style={{
                    padding: "2.5px",
                  }}
                /> */}
                                </div>
                            </div>
                            <div>
                                <div
                                    className="fontRegular"
                                    style={{
                                        display: "inline-block",
                                        marginBottom: "10px",
                                        paddingTop: "1rem",
                                    }}>
                                    Credit Card Upload <br />{" "}
                                    <span style={{ fontSize: "10pt", color: "grey" }}>
                                        Please upload scanned images of the front and back of your credit card. If you
                                        have already uploaded these images, you may skip this step.
                                    </span>
                                </div>
                                {/* <span style={{ color: "red", display: "inline-block" }}>*</span> */}
                                <br />
                                <input type="file" id="car1" onChange={car1Change} />
                                <input type="file" id="car2" onChange={car2Change} />
                                <div
                                    style={{
                                        paddingBottom: "0.4rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        paddingTop: "0.6rem",
                                    }}>
                                    <div
                                        className="loadHandle"
                                        style={{
                                            height: "9rem",
                                            width: "12rem",
                                            backgroundColor: "white",
                                            borderRadius: "1.2rem",
                                            marginRight: "0.6rem",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            position: "relative",
                                            overflow: "hidden",
                                        }}
                                        onClick={() => {
                                            const img1 = document.getElementById("car1");

                                            if (!picUploading1) {
                                                img1.click();
                                            }
                                        }}>
                                        {picUploading1 && (
                                            <div
                                                className="fontRegular"
                                                style={{
                                                    position: "absolute",
                                                    height: "100%",
                                                    width: "100%",
                                                    textAlign: "center",
                                                    backgroundColor: "white",
                                                    color: "#acacb9",
                                                }}>
                                                Uploading...
                                            </div>
                                        )}
                                        <img
                                            src={front}
                                            alt=""
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                border: "none",
                                                outline: "none",
                                            }}
                                        />
                                        <img src={CreditFront} alt="" style={{ height: "4rem" }} />
                                        <div
                                            className="fontSemi"
                                            style={{
                                                textAlign: "center",
                                                fontSize: "0.7rem",
                                                paddingTop: "0.2rem",
                                                color: "#acacb9",
                                            }}>
                                            Click here to
                                            <br />
                                            Upload Front Side
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            height: "9rem",
                                            width: "12rem",
                                            backgroundColor: "white",
                                            borderRadius: "1.2rem",
                                            marginRight: "0.6rem",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            position: "relative",
                                            overflow: "hidden",
                                        }}
                                        onClick={() => {
                                            const img2 = document.getElementById("car2");

                                            if (!picUploading2) {
                                                img2.click();
                                            }
                                        }}>
                                        {picUploading2 && (
                                            <div
                                                className="fontRegular"
                                                style={{
                                                    position: "absolute",
                                                    height: "100%",
                                                    width: "100%",
                                                    textAlign: "center",
                                                    backgroundColor: "white",
                                                    color: "#acacb9",
                                                }}>
                                                Uploading...
                                            </div>
                                        )}
                                        <img
                                            src={back}
                                            alt=""
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                border: "none",
                                                outline: "none",
                                            }}
                                        />
                                        <img src={CreditBack} alt="" style={{ height: "4rem" }} />
                                        <div
                                            className="fontSemi"
                                            style={{
                                                textAlign: "center",
                                                fontSize: "0.7rem",
                                                paddingTop: "0.2rem",
                                                color: "#acacb9",
                                            }}>
                                            Click here to
                                            <br />
                                            Upload Back Side
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Payment Information */}
                        {/* <div style={{ marginTop: "1rem" }}>

                     {
                        reserveForm.values.pickupDate && reserveForm.values.dropoffDate && !proceed ? (
                        <button style={{
                           marginTop: "1rem",
                           color: "white",
                           marginLeft: "auto",

                        }}
                        className="proceed-further fontbold"
                        onClick={()=>{
                           reserveForm.handleSubmit();
                           testSubmit();
                        }}
                        >

                  <span style={{whiteSpace: "nowrap"}} >Proceed further</span>
                        </button>) :
                         <>
                        {
                           proceed ? (  <button style={{
                              marginTop: "1rem",
                              color: "white",
                              marginLeft: "auto",
                              display: "none"

                           }}
                           className="proceed-further fontbold"
                           onClick={()=>{
                              reserveForm.handleSubmit()

                           }}
                           >

                     <span style={{whiteSpace: "nowrap"}} >Proceed further</span>
                           </button>) : ""
                        }
                        </>
                     }
                     { proceed ? (
                        <Elements stripe={stripePromise}>
                           <CheckoutForm
                              amount={
                                 invoice?.reduce(
                                    (n, { total }) => n + total,
                                    0
                                 ) +
                                 invoice1?.reduce(
                                    (n, { total }) => n + total,
                                    0
                                 )
                              }
                           />
                        </Elements>
                     ) : (
                        ""
                     )}
                  </div> */}
                        {/*
                  <Elements stripe={stripePromise} options={{ clientSecret }} >
                     <PaymentInfoForm/>
                  </Elements> */}

                        {/* Table */}

                        <div
                            style={{
                                width: "90%",
                                marginTop: "50px",
                                marginRight: "80px",
                            }}>
                            <div
                                style={{
                                    position: "relative",
                                }}>
                                <div>
                                    <div
                                        className="fontbold"
                                        style={{
                                            display: "inline-block",
                                        }}>
                                        Table
                                    </div>
                                </div>
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "7%",
                                        left: "171%",
                                    }}>
                                    <div
                                        style={{ display: "inline ", cursor: "pointer" }}
                                        onClick={() => openModal2()}
                                        id="myBtn2"
                                        className="add-edit">
                                        ADD
                                    </div>
                                    &nbsp;
                                    <h1 style={{ display: "inline" }} className="name-style">
                                        or
                                    </h1>
                                    &nbsp;
                                    <div
                                        style={{ display: "inline", cursor: "pointer" }}
                                        className="add-edit"
                                        onClick={() => openModal3()}
                                        id="myBtn3">
                                        EDIT
                                    </div>
                                </div>
                            </div>

                            <div>
                                <table className="table-style">
                                    <tr>
                                        <th className="table-header">
                                            <span
                                                style={{
                                                    marginTop: "1rem",
                                                    display: "inline",
                                                }}>
                                                <input
                                                    type="checkbox"
                                                    name="checkbox"
                                                    value="1"
                                                    id="select-all"
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            selectAllCheckboxes();
                                                            setInvoice1((prev) => [
                                                                ...prev,
                                                                {
                                                                    charge: "Collision Damage Waiver",

                                                                    rate: 9,
                                                                    total: dateDiff * 9,
                                                                },
                                                                {
                                                                    charge: "Excess liability Insurance",
                                                                    rate: 15,
                                                                    total: dateDiff * 15,
                                                                },
                                                                {
                                                                    charge: "NYS Rental Tax",
                                                                    rate: 11.5,
                                                                    total: dateDiff * 11.5,
                                                                },
                                                            ]);
                                                        } else {
                                                            const arr = invoice1;
                                                            deselectAllCheckboxes();
                                                            // var ind = arr.findIndex(
                                                            //   (n) => n.charge === "Collision Damage Waiver"
                                                            // );

                                                            // var ind2 = arr.findIndex(
                                                            //   (n) => n.charge === "NYS Rental Tax"
                                                            // );
                                                            // var ind1 = arr.findIndex(
                                                            //   (n) => n.charge === "Excess liability Insurance"
                                                            // );
                                                            // console.log(ind);
                                                            // arr.splice(ind, 1);
                                                            // arr.splice(ind1, 1);
                                                            // arr.splice(ind2, 1);
                                                            arr.splice(0, arr.length);
                                                            setInvoice1(arr);
                                                            setRerender(render + 1);
                                                        }
                                                    }}
                                                />
                                            </span>
                                            <span className="fontRegular">Option Name</span>
                                        </th>
                                        <th className="table-header">Type</th>
                                        <th className="table-header">Rate</th>
                                    </tr>
                                    <tr className="table-row">
                                        <td>
                                            <span
                                                style={{
                                                    marginTop: "1.9rem",
                                                    display: "inline",
                                                }}>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            setInvoice1((prev) => [
                                                                ...prev,
                                                                {
                                                                    charge: "Collision Damage Waiver",

                                                                    rate: 9,
                                                                    total: dateDiff * 9,
                                                                },
                                                            ]);
                                                        } else {
                                                            const arr = invoice1;
                                                            const ind = arr.findIndex(
                                                                (n) => n.charge === "Collision Damage Waiver",
                                                            );
                                                            arr.splice(ind, 1);
                                                            setInvoice1(arr);
                                                            setRerender(render + 1);
                                                        }
                                                    }}
                                                />
                                            </span>
                                            <span className="fontRegular">Collision Damage Waiver</span>
                                        </td>
                                        <td>Insurance</td>
                                        <td>$9.5</td>
                                    </tr>
                                    <tr className="table-row">
                                        <td>
                                            <span
                                                style={{
                                                    marginTop: "1rem",
                                                    display: "inline",
                                                }}>
                                                <input
                                                    type="checkbox"
                                                    id="demoCheckbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            setInvoice1((prev) => [
                                                                ...prev,
                                                                {
                                                                    charge: " Excess liability Insurance",
                                                                    rate: 15,
                                                                    total: dateDiff * 15,
                                                                },
                                                            ]);
                                                        } else {
                                                            const arr = invoice1;
                                                            const ind = arr.findIndex(
                                                                (n) => n.charge === " Excess liability Insurance",
                                                            );
                                                            arr.splice(ind, 1);
                                                            setInvoice1(arr);
                                                            setRerender(render + 1);
                                                        }
                                                    }}
                                                />
                                            </span>
                                            <span className="fontRegular">Excess liability Insurance</span>
                                        </td>
                                        <td>Insurance</td>
                                        <td>$15.00</td>
                                    </tr>
                                    <tr className="table-row">
                                        <td>
                                            <span
                                                style={{
                                                    marginTop: "1rem",
                                                    display: "inline",
                                                }}>
                                                <input
                                                    type="checkbox"
                                                    id="demoCheckbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            setInvoice1((prev) => [
                                                                ...prev,
                                                                {
                                                                    charge: "NYS Rental Tax",
                                                                    rate: 11.5,
                                                                    total: dateDiff * 11.5,
                                                                },
                                                            ]);
                                                        } else {
                                                            const arr = invoice1;
                                                            const ind = arr.findIndex(
                                                                (n) => n.charge === "NYS Rental Tax",
                                                            );
                                                            arr.splice(ind, 1);
                                                            setInvoice1(arr);
                                                            setRerender(render + 1);
                                                        }
                                                    }}
                                                />
                                            </span>
                                            <span className="fontRegular"> NYS Rental Tax</span>
                                        </td>
                                        <td>Insurance</td>
                                        <td>$11.5</td>
                                    </tr>
                                </table>
                                {/* <div
                        style={{
                           position: "relative",
                           paddingTop: "9.2rem",
                        }}
                     >
                        <div
                           style={{
                              position: "absolute",
                              left: "155%",
                           }}
                        >
                           <div>
                              <button
                                 className="submit-button"
                                 type="submit"
                                 value="Next"
                              >
                                 {<span className="next">Next</span>}
                                 <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <path
                                       d="M4.16675 10H15.8334"
                                       stroke="white"
                                       stroke-width="2"
                                       stroke-linecap="round"
                                       stroke-linejoin="round"
                                    />
                                    <path
                                       d="M10 4.16675L15.8333 10.0001L10 15.8334"
                                       stroke="white"
                                       stroke-width="2"
                                       stroke-linecap="round"
                                       stroke-linejoin="round"
                                    />
                                 </svg>
                              </button>
                           </div>
                        </div>
                     </div> */}
                            </div>
                        </div>
                    </div>

                    {/* Action and Submit */}
                    <div className="action">
                        <div>
                            <div className="fontbold" style={{ color: "white" }}>
                                Action:
                            </div>
                        </div>
                        <div
                            style={{
                                paddingTop: "5px",
                            }}>
                            <input type="checkbox" id="html" name="fav_language" value="HTML" checked />
                            <span className="fontRegular" style={{ color: "white" }}>
                                Confirmed
                            </span>
                            <input type="checkbox" id="html" name="fav_language" value="HTML" disabled />
                            <span className="fontRegular" style={{ color: "white" }}>
                                Send email
                            </span>
                            <input type="checkbox" id="html" name="fav_language" value="HTML" disabled />
                            <span className="fontRegular" style={{ color: "white" }}>
                                Tentative
                            </span>
                            <input type="checkbox" id="html" name="fav_language" value="HTML" disabled />
                            <span className="fontRegular" style={{ color: "white" }}>
                                Cancelled
                            </span>
                            <input type="checkbox" id="html" name="fav_language" value="HTML" disabled />
                            <span className="fontRegular" style={{ color: "white" }}>
                                Rented
                            </span>
                            <input type="checkbox" id="html" name="fav_language" value="HTML" disabled />
                            <span className="fontRegular" style={{ color: "white" }}>
                                Checked In
                            </span>
                        </div>
                        {/* {
              isSubmit ? ( <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ flex: "1" }}></div>
              <div
                style={{
                  marginTop: "1.9rem",
                  // paddingLeft: "60.5rem",
                  marginRight: "2rem",
                }}
              >
                <button
                  className="save-button"

                  // onClick={() => {
                  //   reserveForm.handleSubmit();
                  //   // testSubmit("gjvXWrzLTs7YhiZanfHT")
                  // }}
                >
                  {<span className="save">Submitting....</span>}
                </button>
              </div>
            </div>) : (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ flex: "1" }}></div>
              <div
                style={{
                  marginTop: "1.9rem",
                  // paddingLeft: "60.5rem",
                  marginRight: "2rem",
                }}
              >
                <button
                  className="save-button"

                  onClick={() => {
                    reserveForm.handleSubmit();
                    // testSubmit("gjvXWrzLTs7YhiZanfHT")
                  }}
                >
                  {<span className="save">Submit</span>}
                </button>
              </div>
            </div>)
            } */}

                        {/* <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ flex: "1" }}></div>

            </div> */}
                        <div
                            style={{
                                marginTop: "1.9rem",
                                // paddingLeft: "60.5rem",
                                marginRight: "2rem",
                            }}>
                            <button
                                className="save-button"
                                onClick={() => {
                                    reserveForm.handleSubmit();
                                    // testSubmit("gjvXWrzLTs7YhiZanfHT")
                                }}>
                                {<span className="save">Submit</span>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default CustomerReservation;
